import AnimatedArrow from './AnimatedArrow'
export default AnimatedArrow
